import React from 'react'
import { InputAdornment, TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import "@material/react-text-field/dist/text-field.css";
import { useFormik } from "formik";
import { JSEncrypt } from "jsencrypt";
import { useEffect, useState } from "react";
import Carousel from "react-bootstrap/Carousel";
import GoogleLogin from "react-google-login";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect, shallowEqual, useDispatch, useSelector } from "react-redux";
import { Link, Redirect } from "react-router-dom";
import * as Yup from "yup";
import { toAbsoluteUrl } from "../../../../Utils/_helpers";
import { Tracker } from "../../../util/analytics";
import {
  API_PUBLIC_KEY,
  APP_CONSTANT,
  APP_INFOGRAPICS,
} from "../../../util/constants";
import * as auth from "../_redux/authRedux";
import { actionTypes } from "../_redux/authRedux";
import StartFreeTrial from "./StartFreeTrial";
import { isLoggedIn } from '../../../util/helpers';

var date = new Date();
var time = date.getTime();
const email = "email22-" + time;

const initialValues = {
  password: "",
};
initialValues[email] = "";

function Login(props) {
  const [tokenStatus, setTokenStatus] = useState(0);
  const dispatch = useDispatch();

  const { sso_token } = useSelector(
    ({ auth }) => ({
      sso_token: auth.sso_token,
    }),
    shallowEqual
  );
  const autoLogin = async () => {
    try {
      const params = { token: sso_token };
      const encrypt = new JSEncrypt();
      encrypt.setPublicKey(API_PUBLIC_KEY);
      const onSuccess = (data) => {
        if (data["status"] !== 200) {
          setTokenStatus(data["status"]);
        } else {
          setTokenStatus(data["status"]);
        }
      };

      const onError = (data) => {
        setTokenStatus(data.error.log.response.statusTxt);
      };
      dispatch({
        type: actionTypes.SSOLogin,
        payload: params,
        onSuccess,
        onError,
      });
      return;
    } catch (error) {
      setTokenStatus(error.response["status"]);
      return error.response;
    }
  };

  const { intl } = props;
  const [loading, setLoading] = useState(false);
  const [showOverlay, setOverlay] = useState(false);
  const [passwordShown, setPasswordShown] = useState(false);
  var showPasswordIconUrl = toAbsoluteUrl("/media/sr/icons/eye_open.svg");
  var hidePasswordIconUrl = toAbsoluteUrl("/media/sr/icons/eye_close.svg");
  const schemaData = {
    password: Yup.string().required(
      intl.formatMessage({
        id: "Auth_validation-required-field",
      })
    ),
  };
  schemaData[email] = Yup.string().required(
    intl.formatMessage({
      id: "Auth_validation-required-field",
    })
  );
  const LoginSchema = Yup.object().shape(schemaData);

  const responseGoogleSuccess = (response) => {
    const payload = {
      email: response.profileObj.email,
      first_name: response.profileObj.name,
      img: response.profileObj.imageUrl,
      response: response,
    };
    enableLoading();
    formik.setSubmitting(true);
    dispatch(
      auth.actions.loginSocial(
        payload,
        (response) => {
          Tracker.event("AUTH", "google-login", "google-login-success");
          handleSuccessMessage(response);
          formik.setSubmitting(false);
          disableLoading();
        },
        (response) => {
          Tracker.event("AUTH", "google-login", "google-login-error");
          handleErrorMessage(response);
          formik.setSubmitting(false);
          disableLoading();
        }
      )
    );
  };

  const responseGoogleError = (response) => {
    Tracker.event("AUTH", "google-login", "google-login-error");
  };

  const enableLoading = () => {
    setLoading(true);
  };

  const disableLoading = () => {
    setLoading(false);
  };

  const toggelOverlay = () => {
    setOverlay(!showOverlay);
  };

  const handleSuccessMessage = (response) => {
    if (response.status === 200) {
      formik.setStatus({
        isSuccess: true,
        message: "",
        message2: "User logged-in successful.",
      });
    } else {
      formik.setStatus({ isSuccess: false, message: response.error.message });
    }
  };

  const handleErrorMessage = (response) => {
    formik.setStatus({ isSuccess: false, message: response.error.message });
  };

  const filledInputClass = (fieldname) => {
    if (formik.values[fieldname].length) {
      return "is-filled";
    }
    return "";
  };

  const toggelPasswordInput = () => {
    setPasswordShown(passwordShown ? false : true);
  };

  const formik = useFormik({
    initialValues,
    validationSchema: LoginSchema,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: function(values, { setStatus, setSubmitting }) {
      formik.setStatus(null);
      enableLoading();
      const encrypt = new JSEncrypt();
      encrypt.setPublicKey(API_PUBLIC_KEY);
      let encryptedPassword = encrypt.encrypt(values.password);
      dispatch(
        auth.actions.login(
          { username: values[email], password: encryptedPassword },
          (response) => {
            handleSuccessMessage(response);
            setSubmitting(false);
            disableLoading();
          },
          (response) => {
            handleErrorMessage(response);
            setSubmitting(false);
            disableLoading();
          }
        )
      );
    },
  });

  const useStylesReddit = makeStyles((theme) => ({
    root: {
      border2: "1px solid #e2e2e1",
      overflow: "hidden",
      borderRadius: 4,
      backgroundColor: "#fcfcfb",
      transition: theme.transitions.create(["border-color", "box-shadow"]),
      "&:hover": {
        backgroundColor: "#fff",
      },
      "&$focused": {
        backgroundColor: "#fff",
        borderColor: theme.palette.primary.main,
      },
      "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
        borderColor: "transparent",
      },
      "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
        borderColor: "purple",
      },
      "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "purple",
      },
    },
    focused: {},
  }));

  const classes = useStylesReddit();

  const useStyles = makeStyles({
    root: {
      backgroundColor: "white",
      "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
        borderColor: "purple",
      },
      "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
        borderColor: "purple",
      },
      "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "purple",
      },
      "& .MuiFormLabel-root.Mui-focused": {
        color: "purple",
      },
    },
  });

  const classes2 = useStyles();
  useEffect(() => {
    if (tokenStatus === 0 && sso_token && sso_token !== "") {
      autoLogin();
    } 
    else if((!sso_token || sso_token == "") && !isLoggedIn() && process.env.REACT_APP_ENV !== 'dev') {
      window.location = process.env.REACT_APP_IFRAME_BASE_URL;
    }
  }, [tokenStatus, sso_token]);

  if (tokenStatus === 200) {
    window.location = "/";
    return <Redirect to="/" />;
  }

  return (
    <div className="sr-login-form login-signin" id="kt_login_signin_form">
      <div
        className={`lgn-ovr d-block d-lg-none ${showOverlay ? "shw-ovr" : ""} `}
        style={showOverlay ? { zIndex: 2 } : {}}
      >
        <div
          href="#"
          style={{
            position: "absolute",
            zIndex: 10,
            top: "22px",
            right: "25px",
            width: "50px",
            height: "50px",
          }}
          onClick={toggelOverlay}
        >
          <button
            href="#"
            style={{ top: "0px", right: "0px" }}
            className="link-button lgn-ovr-closebtn "
            onClick={toggelOverlay}
          >
            <img
              alt=""
              src={toAbsoluteUrl("/media/sr/icons/cross_arrow.svg")}
              className="overlay-cross-icon"
            />
          </button>
        </div>
        <div className="lgn-ovr-content px-3">
          <div className="text-center">
            <div className="login-carousel">
              <Carousel controls={false}>
                {APP_INFOGRAPICS.map((citem) => (
                  <Carousel.Item interval={300} key={citem.id}>
                    <img
                      className="d-block caro-img"
                      src={toAbsoluteUrl(citem.image)}
                      alt={citem.title}
                    />
                    <a
                      className={"ga_link"}
                      href={citem.redirect_url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Carousel.Caption>
                        <h3 className="main-title">
                          <FormattedMessage
                            id={citem.title}
                            defaultMessage="Title"
                          />
                        </h3>
                        <p className="sub-title">
                          <FormattedMessage
                            id={citem.sub_title}
                            defaultMessage="Sub Title"
                          />
                        </p>
                      </Carousel.Caption>
                    </a>

                    <div className="lets-cnt">
                      <a
                        target="_blank"
                        href={citem.redirect_url}
                        className="link-button link-clr"
                        rel="noreferrer"
                      >
                        <FormattedMessage
                          id="Auth_general-free-trial2"
                          defaultMessage="Let’s Connect to Know More"
                        />
                        &nbsp;&nbsp;
                        <img
                          alt=""
                          src={toAbsoluteUrl("/media/sr/icons/right-arrow.svg")}
                          className="right-icon"
                        />
                      </a>
                    </div>
                  </Carousel.Item>
                ))}
              </Carousel>
            </div>
          </div>
        </div>
      </div>

      <div className="d-none d-lg-block">
        <img
          alt=""
          src={toAbsoluteUrl("/media/sr/logos/main-logo.svg")}
          className="main-logo"
        />
      </div>

      <div>
        <p className="greet-title">
          <FormattedMessage id="Auth_general-hello" defaultMessage="Hello!" />
        </p>
      </div>

      <form
        onSubmit={formik.handleSubmit}
        className="form fv-plugins-bootstrap fv-plugins-framework"
        autoComplete="off"
      >
        <input
          autocomplete="off"
          name="hidden"
          type="text"
          style={{ display: "none" }}
        ></input>

        <div className="fv-plugins-icon-container sr-first-input sr-form-input">
          <TextField
            label={intl.formatMessage({
              id: "auth_input-username-title",
              defaultMessage: "Username or Email",
            })}
            outlined={true}
            variant="outlined"
            fullWidth
            autoFocus={false}
            className={classes2.root}
            InputProps={{ classes, disableUnderline: true }}
            className2={`iemail sr-input-outline ${filledInputClass(email)}`}
            color="primary"
            autoComplete="off"
            name={email}
            {...formik.getFieldProps(email)}
          ></TextField>

          {(formik.isSubmitting || formik.touched[email]) &&
          (formik.touched ||
            formik.values[email].length > 0 ||
            formik.isSubmitting) &&
          formik.errors[email] ? (
            <div className="fv-plugins-message-container">
              <div className="fv-help-block">{formik.errors[email]}</div>
            </div>
          ) : null}
        </div>
        <div className="fv-plugins-icon-container sr-form-input">
          <TextField
            label={intl.formatMessage({
              id: "Auth_input-password",
              defaultMessage: "Password",
            })}
            outlined="true"
            variant="outlined"
            color="secondary"
            fullWidth
            className={classes2.root}
            className2={`ipassword sr-input-outline2 ${filledInputClass(
              "password"
            )}`}
            autoComplete2="new-password"
            InputProps={{
              classes,
              disableUnderline: true,
              endAdornment: (
                <InputAdornment position="end">
                  <div
                    className="post-icon"
                    onClick={() => toggelPasswordInput()}
                  >
                    <img
                      alt=""
                      id="show-hide-password"
                      src={
                        passwordShown
                          ? showPasswordIconUrl
                          : hidePasswordIconUrl
                      }
                      className="hide-password-icon"
                    />
                  </div>
                </InputAdornment>
              ),
            }}
            trailingIcon={
              <div className="post-icon" onClick={() => toggelPasswordInput()}>
                <img
                  alt=""
                  id="show-hide-password"
                  src={
                    passwordShown ? showPasswordIconUrl : hidePasswordIconUrl
                  }
                  className="hide-password-icon"
                />
              </div>
            }
            onTrailingIconSelect={toggelPasswordInput}
            name="password"
            type={passwordShown ? "text" : "password"}
            {...formik.getFieldProps("password")}
          ></TextField>

          {(formik.isSubmitting || formik.touched.password) &&
          (formik.touched ||
            formik.values.password.length > 0 ||
            formik.isSubmitting) &&
          formik.errors.password ? (
            <div className="fv-plugins-message-container">
              <div className="fv-help-block">{formik.errors.password}</div>
            </div>
          ) : null}
        </div>

        {formik.status && !formik.status.isSuccess && (
          <div className="mb-2">
            <div className="fv-plugins-message-container">
              <div className="fv-help-block">{formik.status.message}</div>
            </div>
          </div>
        )}

        <div className="forget-section">
          <Link to="/forgotPassword" className="link-clr" id="kt_login_forgot">
            <FormattedMessage
              id="Auth_forgot-title"
              defaultMessage="Forgot Password?"
            />
          </Link>
        </div>

        {formik.status && formik.status.isSuccess && (
          <div className="mb-2">
            <div className="fv-plugins-message-container">
              <div className="fv-help-block">{formik.status.message}</div>
            </div>
          </div>
        )}

        <div className="form-group">
          <button
            id="kt_login_signin_submit"
            type="submit"
            disabled={formik.isSubmitting}
            className={`btn btn-block sbt-btn mb-4 action-login`}
          >
            <span>
              <FormattedMessage id="Auth_login-button" defaultMessage="Login" />
            </span>
            {loading && <span className="ml-3 spinner spinner-white"></span>}
          </button>
        </div>
      </form>
      <div className="form-group mb-0">
        <div className="text-center">
          <GoogleLogin
            clientId={process.env.REACT_APP_GOOGLE_LOGIN_CLIENT_ID}
            render={(renderProps) => (
              <button
                className="sign-in-google-btn"
                onClick={renderProps.onClick}
              >
                <img
                  alt=""
                  src={toAbsoluteUrl("/media/sr/logos/google.svg")}
                  className="google-icon"
                ></img>
                <span className="sign-in-with-Google">
                  Continue with Google
                </span>
              </button>
            )}
            buttonText="Sign in with Google"
            className="google-btn mb-8 action-google-login"
            onRequest={() => {
              Tracker.event("AUTH", "google-login", "google-login-clicked");
            }}
            onSuccess={responseGoogleSuccess}
            onFailure={responseGoogleError}
            cookiePolicy={"single_host_origin"}
          />
        </div>
        <div className="text-center" style={{ fontSizedd: "14px" }}>
          <p className="fre-tr-txt" style={{ width: "320px" }}>
            <span className="text-muted" style={{ fontSizedd: "14px" }}>
              <FormattedMessage
                id="Auth_general-no-account"
                defaultMessage="Don't Have an Account?"
              />
            </span>
            &nbsp;
            <StartFreeTrial></StartFreeTrial>
          </p>
        </div>
        <div className="powered-section text-center">
          <a
            target="_blank"
            href={APP_CONSTANT.POWERED_BY_LINK}
            rel="noreferrer"
          >
            <img
              alt=""
              src={toAbsoluteUrl("/media/sr/icons/powered-by.png")}
              className="right-icon"
            />
          </a>
        </div>
        <div className="site-footer mt-4 mb-8 text-center d-block d-lg-none">
          Copyright &#169; {APP_CONSTANT.COPYRIGHT_YEAR}, Knowlarity
          Communications Pvt. Ltd | Powered by Knowlarity | &nbsp;
          <a
            href={APP_CONSTANT.SR_POLICY_LINK}
            target="_blank"
            className="link-clr"
            rel="noreferrer"
          >
            Privacy Policy
          </a>{" "}
          | &nbsp;
          <a
            href={APP_CONSTANT.SR_TERMS_LINK}
            target="_blank"
            className="link-clr"
            rel="noreferrer"
          >
            Terms &amp; Conditions
          </a>
        </div>
      </div>

      <div className="d-block d-lg-none text-center">
        <div className="toggler" onClick={toggelOverlay}>
          <div className="chk-nw-ftr">
            <FormattedMessage
              id="Auth_general-check-new-features"
              defaultMessage="Check New Features"
            />
          </div>
          <div>
            <button className="link-button" onClick={toggelOverlay}>
              <img
                alt=""
                src={toAbsoluteUrl("/media/sr/icons/angle-down.svg")}
                className="angle-down"
              ></img>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default injectIntl(connect(null, auth.actions)(Login));
